import { GET_PERMISSIONS_ERROR, GET_PERMISSIONS_SUCCESS, GET_PERMISSIONS_START } from '../../types';

export default function permissions(state, action) {
  switch (action.type) {
    case GET_PERMISSIONS_START:
      return { ...state };
    case GET_PERMISSIONS_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case GET_PERMISSIONS_ERROR:
      return {
        ...state,
        data: [],
        error: action.detail
      };
    default:
      return { ...state };
  }
}
